<template>
  <div class="box">
    <div class="headline">
      <div class="top">Step 2 of 5</div>
      Deployment
    </div>
    <b-form>
      <b-form-group description="Do you want to use pipenv or python venv for project setup?">
        <b-form-checkbox v-model="devops.use_pipenv">Use pipenv</b-form-checkbox>
      </b-form-group>

      <b-form-group description="Create a Dockerfile for docker-based deployment?">
        <b-form-checkbox v-model="devops.use_docker">Docker support</b-form-checkbox>
      </b-form-group>
      <b-form-group description="Create a Procfile for deploying on Heroku?">
        <b-form-checkbox v-model="devops.use_heroku">Heroku support</b-form-checkbox>
      </b-form-group>
      <b-form-group description="Set up GitHub Actions workflow for CI/CD?">
        <b-form-checkbox v-model="devops.use_github_actions">GitHub Actions support</b-form-checkbox>
      </b-form-group>
      <b-form-group description="Set up Celery for running background tasks">
        <b-form-checkbox v-model="useCelery">Celery support</b-form-checkbox>
      </b-form-group>

      <b-form-group description="Support running behind a reverse proxy (Cloudflare, ELB, haproxy, nginx, ...)">
        <b-form-checkbox v-model="devops.use_reverse_proxy">Reverse proxy support</b-form-checkbox>
      </b-form-group>
    </b-form>
    <b-form>
      <h4 class="mt-2">Static and media file handling</h4>
      <p class="text-small">
        Here, <em>static files</em> refers to the files that are part of your project
        source code (committed to your repository), and <em>media files</em> means files uploaded by your
        user, regardless of the file type.
      </p>

      <b-form-group label="Uploaded/Media file storage" description="How to handle uploaded (media) files">
        <b-form-select v-model="devops.use_storages" :options="FILE_STORAGE_OPTIONS"></b-form-select>
      </b-form-group>

      <b-form-group label="Static file serving" description="How to serve static files part of the project">
        <b-form-select v-model="devops.static_files_handler" :options="STATIC_FILES_OPTIONS"></b-form-select>
      </b-form-group>

      <p v-if="devops.static_files_handler === 'none'">
        <strong>Note</strong>: This requires a web server (Nginx, Apache, or similar) to serve
        the static files from a local directory on the server where you deploy your project.
      </p>

      <b-form-group
        v-if="devops.static_files_handler === 'whitenoise'"
        description="Enable compression and caching of static files served with whitenoise"
      >
        <b-form-checkbox v-model="devops.use_whitenoise_cc">Enable compression and caching</b-form-checkbox>
      </b-form-group>
    </b-form>

    <b-form>
      <h4 class="mt-2">E-mail support</h4>
      <b-form-group label="E-mail service provider" description="Which provider to use to send e-mail">
        <b-form-select v-model="devops.email_provider" :options="EMAIL_PROVIDER_OPTIONS"></b-form-select>
      </b-form-group>

      <div class="button-row">
        <b-button @click="$emit('prev', { devops, useCelery })">← Prev</b-button>
        <b-button variant="primary" @click="$emit('next', { devops, useCelery })">Next &rarr;</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  FILE_STORAGE_OPTIONS,
  STATIC_FILES_OPTIONS,
  EMAIL_PROVIDER_OPTIONS
} from '../../helpers/constants'

function objectOptions (obj) {
  const opts = []
  for (let k in obj) {
    opts.push({
      value: k,
      text: obj[k]
    })
  }
  return opts
}

export default {
  name: 'Deployment',

  props: {
    recipe: {type: Object, required: true}
  },

  data () {
    const devops = { ...this.recipe.devops }
    const useCelery = !!this.recipe.use_celery

    if (!devops.static_files_handler) devops.static_files_handler = ''
    if (!devops.use_storages) devops.use_storages = ''
    if (!devops.email_provider) devops.email_provider = ''

    return {
      devops,
      useCelery
    }
  },

  computed: {
    STATIC_FILES_OPTIONS: () => objectOptions(STATIC_FILES_OPTIONS),
    FILE_STORAGE_OPTIONS: () => objectOptions(FILE_STORAGE_OPTIONS),
    EMAIL_PROVIDER_OPTIONS: () => objectOptions(EMAIL_PROVIDER_OPTIONS)
  },

  watch: {
    'devops.static_files_handler': function () {
      if (this.devops.static_files_handler === 'storages' && !this.devops.use_storages) {
        this.devops.use_storages = 'aws-s3'
      }
      if (this.devops.static_files_handler !== 'whitenoise') {
        this.devops.use_whitenoise_cc = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wizard/Deployment.vue